module.exports = __webpack_public_path__ + "img/deposit-icon.cf46afe9.svg";